import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../stores/platformAuthStore';
import { formStyles as styles } from '../components/formStyles';

export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('The two passwords do not match');
      return;
    }
    setBusy(true);
    setError('');
    const r = await useAuthStore.getState().resetPassword(token, password);
    setBusy(false);
    if (r.ok) {
      // Every session was signed out, this browser's included.
      useAuthStore.getState().logout();
      setDone(true);
    } else setError(r.error ?? 'Something went wrong');
  };

  return (
    <div style={styles.container}>
      <form style={styles.card} onSubmit={handleSubmit}>
        <h2 style={styles.title}>Choose a new password</h2>
        {done ? (
          <p style={styles.text}>Your password is changed and every session was signed out.</p>
        ) : (
          <>
            {error && <div style={styles.error}>{error}</div>}
            <div style={styles.field}>
              <label style={styles.label}>New password</label>
              <input
                style={styles.input}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                autoFocus
                autoComplete="new-password"
              />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>New password again</label>
              <input
                style={styles.input}
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            <button style={styles.btn} type="submit" disabled={busy || !token}>
              {busy ? 'Saving...' : 'Set new password'}
            </button>
          </>
        )}
        <div style={styles.footer}>
          <Link to="/login" style={styles.link}>
            Log in
          </Link>
        </div>
      </form>
    </div>
  );
}
